import { Controller } from "@hotwired/stimulus";

// Enables the delete button only when restaurant name matches and secret is filled
export default class extends Controller {
  static targets = ["nameInput", "secretInput", "submitButton"];
  static values = { name: String };

  validate() {
    const nameMatches = this.nameInputTarget.value === this.nameValue;
    const secretFilled = this.secretInputTarget.value.length > 0;

    this.submitButtonTarget.disabled = !(nameMatches && secretFilled);
  }
}
